import React from 'react';
import { Icon } from '@/components/ui/Icon';
import { LogoImage } from '@/components/ui/LogoImage';
import { useTheme } from '@/hooks/useTheme';
import type { Club } from '@/types';

interface ClubCardProps {
  club: Club;
  onPress?: () => void;
}

export function ClubCard({ club, onPress }: ClubCardProps) {
  const colors = useTheme();

  return (
    <button
      onClick={onPress}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
        borderRadius: 16,
        padding: 16,
        border: `1px solid ${colors.border}`,
        marginBottom: 8,
        backgroundColor: colors.surface,
        width: '100%',
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 16,
          padding: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.background,
          flexShrink: 0,
        }}
      >
        <LogoImage uri={club.logo} size={40} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: colors.text,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {club.nom}
        </div>
        {club.ville && (
          <div style={{ fontSize: 12, marginTop: 2, color: colors.textSecondary }}>{club.ville}</div>
        )}
      </div>
      <Icon name="chevron-forward" size={20} color={colors.textSecondary} />
    </button>
  );
}
